import 'angular:locale/data:en';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en";
